(function () {
  // If cart was modified, reload to get fresh state (handles browser back)
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      window.location.reload();
      return;
    }
  });
  if (sessionStorage.getItem('_cart_modified')) {
    sessionStorage.removeItem('_cart_modified');
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var renderedKeys = [];
        document.querySelectorAll('[data-remove-rental]').forEach(function(el) {
          renderedKeys.push(el.dataset.removeRental);
        });
        var actualKeys = cart.items
          .filter(function(item) { return item.properties && item.properties._rental_item === 'true'; })
          .map(function(item) { return item.key; });
        if (renderedKeys.length !== actualKeys.length || renderedKeys.sort().join(',') !== actualKeys.sort().join(',')) {
          window.location.reload();
        }
      });
  }

  // Restore rental items from sessionStorage if returning from checkout
  var backup = sessionStorage.getItem('_rental_cart_backup');
  if (backup) {
    sessionStorage.removeItem('_rental_cart_backup');
    try {
      var items = JSON.parse(backup);
      if (items.length > 0) {
        var addPromises = items.map(function (item) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.id,
              quantity: 1,
              properties: item.properties
            })
          });
        });
        Promise.all(addPromises).then(function () {
          window.location.reload();
        });
        return;
      }
    } catch (e) {}
  }

  var section = document.getElementById('rental-cart-section');
  if (!section) return;

  var DURATION = 7;
  var MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  var DAY_HEADERS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

  var grid = section.querySelector('[data-rc-grid]');
  var monthLabel = section.querySelector('[data-rc-month-label]');
  var prevBtn = section.querySelector('[data-rc-prev]');
  var nextBtn = section.querySelector('[data-rc-next]');
  var dateSummaryEl = section.querySelector('[data-rc-date-summary]');
  var dateText = section.querySelector('[data-rc-date-text]');
  var detailsEl = section.querySelector('[data-rc-details]');
  var policyCheck = section.querySelector('[data-rc-policy-check]');
  var submitBtn = section.querySelector('[data-rc-submit]');
  var removeButtons = section.querySelectorAll('[data-remove-rental]');

  var selectedDate = null;
  var currentMonth = new Date();
  currentMonth.setDate(1);

  function formatDateShort(date) {
    return MONTH_NAMES[date.getMonth()].slice(0, 3) + ' ' + date.getDate() + ', ' + date.getFullYear();
  }

  function isSameDay(a, b) {
    return a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate();
  }

  function isInRange(date, start, days) {
    if (!start) return false;
    var end = new Date(start);
    end.setDate(end.getDate() + days - 1);
    return date >= start && date <= end;
  }

  function isPast(date) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
  }

  function renderCalendar() {
    var year = currentMonth.getFullYear();
    var month = currentMonth.getMonth();
    monthLabel.textContent = MONTH_NAMES[month] + ' ' + year;

    var html = '';
    for (var i = 0; i < DAY_HEADERS.length; i++) {
      html += '<div class="rental-cart__day-header">' + DAY_HEADERS[i] + '</div>';
    }

    var firstDay = new Date(year, month, 1).getDay();
    var daysInMonth = new Date(year, month + 1, 0).getDate();

    for (var blank = 0; blank < firstDay; blank++) {
      html += '<div class="rental-cart__day rental-cart__day--empty"></div>';
    }

    for (var day = 1; day <= daysInMonth; day++) {
      var date = new Date(year, month, day);
      var classes = ['rental-cart__day'];
      var disabled = false;

      if (isPast(date)) {
        disabled = true;
      }

      if (selectedDate && isSameDay(date, selectedDate)) {
        classes.push('rental-cart__day--start');
      }

      if (selectedDate && isInRange(date, selectedDate, DURATION)) {
        classes.push('rental-cart__day--in-range');
      }

      if (selectedDate) {
        var endDate = new Date(selectedDate);
        endDate.setDate(endDate.getDate() + DURATION - 1);
        if (isSameDay(date, endDate)) {
          classes.push('rental-cart__day--end');
        }
      }

      html += '<button type="button" class="' + classes.join(' ') + '"' +
        ' data-date="' + year + '-' + String(month + 1).padStart(2, '0') + '-' + String(day).padStart(2, '0') + '"' +
        (disabled ? ' disabled' : '') +
        '>' + day + '</button>';
    }

    grid.innerHTML = html;
  }

  function updateDateSummary() {
    if (!selectedDate) {
      if (dateSummaryEl) dateSummaryEl.style.display = 'none';
      return;
    }
    var endDate = new Date(selectedDate);
    endDate.setDate(endDate.getDate() + DURATION - 1);
    if (dateSummaryEl) {
      dateSummaryEl.style.display = '';
      dateText.textContent = formatDateShort(selectedDate) + ' \u2013 ' + formatDateShort(endDate) + ' (7 days)';
    }
  }

  function updateSubmitState() {
    var nameVal = document.getElementById('rental-name').value.trim();
    var emailVal = document.getElementById('rental-email').value.trim();
    var detailsVal = document.getElementById('rental-details').value.trim();
    var policyChecked = policyCheck.checked;
    var dateSelected = selectedDate !== null;

    submitBtn.disabled = !(nameVal && emailVal && detailsVal && policyChecked && dateSelected);
  }

  grid.addEventListener('click', function (e) {
    var btn = e.target.closest('.rental-cart__day[data-date]');
    if (!btn || btn.disabled) return;
    var parts = btn.dataset.date.split('-');
    selectedDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
    renderCalendar();
    updateDateSummary();
    updateSubmitState();
  });

  prevBtn.addEventListener('click', function () {
    currentMonth.setMonth(currentMonth.getMonth() - 1);
    renderCalendar();
  });

  nextBtn.addEventListener('click', function () {
    currentMonth.setMonth(currentMonth.getMonth() + 1);
    renderCalendar();
  });

  policyCheck.addEventListener('change', updateSubmitState);
  document.getElementById('rental-name').addEventListener('input', updateSubmitState);
  document.getElementById('rental-email').addEventListener('input', updateSubmitState);
  document.getElementById('rental-details').addEventListener('input', updateSubmitState);

  removeButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.dataset.removeRental;
      var row = btn.closest('.rental-cart__item');
      if (row) { row.style.opacity = '0.3'; row.style.pointerEvents = 'none'; }
      sessionStorage.setItem('_cart_modified', '1');
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [key]: 0 } })
      })
        .then(function () { window.location.reload(); });
    });
  });

  submitBtn.addEventListener('click', function () {
    if (submitBtn.disabled) return;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending...';

    var name = document.getElementById('rental-name').value.trim();
    var email = document.getElementById('rental-email').value.trim();
    var phone = document.getElementById('rental-phone').value.trim();
    var instagram = document.getElementById('rental-instagram').value.trim();
    var details = document.getElementById('rental-details').value.trim();

    var endDate = new Date(selectedDate);
    endDate.setDate(endDate.getDate() + DURATION - 1);

    var items = section.querySelectorAll('.rental-cart__item');
    var itemLines = [];
    items.forEach(function (el) {
      var title = el.querySelector('.rental-cart__item-title');
      var price = el.querySelector('.rental-cart__item-price');
      if (title) {
        var line = '- ' + title.textContent.trim();
        if (price) line += ' (' + price.textContent.trim() + ')';
        itemLines.push(line);
      }
    });

    var body = 'RENTAL INQUIRY\n\n'
      + 'Items:\n' + itemLines.join('\n') + '\n\n'
      + 'Rental Period: ' + formatDateShort(selectedDate) + ' to ' + formatDateShort(endDate) + ' (7 days)\n\n'
      + 'Phone: ' + (phone || 'Not provided') + '\n'
      + 'Instagram: ' + (instagram || 'Not provided') + '\n\n'
      + 'Project Details:\n' + details + '\n';

    var contactForm = document.getElementById('rental-contact-form');
    document.getElementById('rc-form-body').value = body;

    var rentalItems = section.querySelectorAll('.rental-cart__item');
    var updates = {};
    rentalItems.forEach(function (el) {
      var key = el.dataset.key;
      if (key) updates[key] = 0;
    });

    if (Object.keys(updates).length > 0) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () {
        contactForm.submit();
      });
    } else {
      contactForm.submit();
    }
  });


  renderCalendar();

  // Rental policy modal
  var policyOpenBtn = section.querySelector('[data-rc-policy-open]');
  var modalOverlay = section.querySelector('[data-rc-modal-overlay]');
  var modalCloseBtns = section.querySelectorAll('[data-rc-modal-close]');

  if (policyOpenBtn && modalOverlay) {
    policyOpenBtn.addEventListener('click', function (e) {
      e.preventDefault();
      modalOverlay.style.display = 'flex';
    });

    modalCloseBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        modalOverlay.style.display = 'none';
      });
    });

    modalOverlay.addEventListener('click', function (e) {
      if (e.target === modalOverlay) {
        modalOverlay.style.display = 'none';
      }
    });
  }

})();
